import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from 'reactstrap';

import Button from 'ui/common/button';
import styles from './career-timelines-viz-info-modal.module.scss';

const items = [
  {
    src: require('./career-timelines-viz-info-modal.png'),
    altText: 'Slide 1',
    captionHeader: 'What is this timeline?',
    captionText: `Your timeline is a quick visual representation of your career. Going from left to right, it plots your work experience against time. At any given point in time, if you're involved in more than one professional engagement, the individual work experience segments are stacked in parallel.
    For example, Jane who is working as a consultant but also simultaneously the director of a non-profit organization will have two stacked segments to illustrate her involvement in two parallel activities.`,
  },
  {
    src: require('./career-timelines-viz-info-modal.png'),
    altText: 'Slide 2',
    captionHeader: 'What are work experience levels?',
    captionText: `Indorse wants to help you visualize career progression in different ways. By default, the timeline is coloured by work experience levels. Users earn a new level after every 3 years of professional activity:
    <ul class="list-unstyled">
      <li>Yellow <i class="fa fa-square ${styles.segmentYellowMarker}"></i> 0&lt;x&lt;=3 years</li>
      <li>Orange <i class="fa fa-square ${styles.segmentOrangeMarker}"></i> 3&lt;x&lt;=6 years</li>
      <li>Green&nbsp; <i class="fa fa-square ${styles.segmentGreenMarker}"></i> 6&lt;x&lt;=9 years</li>
      <li>Blue&nbsp;&nbsp; <i class="fa fa-square ${styles.segmentBlueMarker}"></i> 9&lt;x&lt;=12 years</li>
      <li>Purple <i class="fa fa-square ${styles.segmentPurpleMarker}"></i> 12&lt;x&lt;=15 years</li>
      <li>Black&nbsp; <i class="fa fa-square ${styles.segmentBlackMarker}"></i> 15&lt;x years</li>
    </ul>`,
  },
  {
    src: require('./career-timelines-viz-info-modal.png'),
    altText: 'Slide 3',
    captionText: `By observing two different timelines, you can quickly visually compare how two people's careers match against each other before reading their profile details.`,
  },
];

class CareerTimlineVizInfoCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = items.map((item, itemIndex) => {
      return (
        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={itemIndex}
          src={item.src}
          altText={item.altText}
        >
          <div className={styles.carouselCaption}>
            {item.captionHeader && <h3>{item.captionHeader}</h3>}
            <p dangerouslySetInnerHTML={{ __html: item.captionText }} />
          </div>
        </CarouselItem>
      );
    });

    return (
      <Modal backdrop="static" size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>Timeline Visualization</ModalHeader>
        <ModalBody>
          <Carousel
            activeIndex={activeIndex}
            next={this.next}
            previous={this.previous}
            interval={false}
          >
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={this.goToIndex}
            />
            {slides}
          </Carousel>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" icon="fa fa-arrow-left" onClick={this.previous}>
            &nbsp; Prev
          </Button>
          <Button color="primary" icon="fa fa-arrow-right" onClick={this.next}>
            Next &nbsp;
          </Button>
          <Button color="secondary" onClick={this.props.toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default CareerTimlineVizInfoCarousel;
